import React from 'react';
import { Box } from '@leagueplatform/genesis-core';
import { RewardsEventController } from '@leagueplatform/rewards-events';

export const RewardsEventControllerWrapper = () => (
  <Box
    css={{
      '.badge-progress-wrapper': {
        backgroundColor: '$surfaceBackgroundSecondary',
      },
      '.badge-progress-wrapper + .GDS-text-action': {
        backgroundColor: '$surfaceBackgroundSecondary',
      },
    }}
  >
    <RewardsEventController />
  </Box>
);
